import { Navigate, Outlet } from 'react-router-dom';
import { useMe } from '@/hooks/useAuth';

export function AuthGuard() {
  const { data: user, isLoading, isError } = useMe();

  if (isLoading) {
    return <div className="flex h-dvh items-center justify-center text-sm text-muted-foreground">Cargando…</div>;
  }

  if (isError || !user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
